// client/src/components/TiptapEditor/MenuBar/ImageGroup.js
import React, { useCallback } from "react";
import { Icon } from "semantic-ui-react";

export const ImageGroup = ({ editor }) => {
  const addImage = useCallback(() => {
    const url = window.prompt("URL de la imagen");

    // Si el usuario provee una URL, usamos el comando setImage de Tiptap
    if (url) {
      editor.chain().focus().setImage({ src: url }).run();
    }
  }, [editor]);

  if (!editor) {
    return null;
  }

  return (
    <button type="button" onClick={addImage}>
      <Icon name="image" />
    </button>
  );
};
